import React, {useState} from "react";
import {Divider, List, message, Button} from "antd";
import {CheckOutlined, LeftOutlined} from "@ant-design/icons";
import routesConfig from "../../routesConfig";
import {PURCHASE_CHANNEL} from "../../constants";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {getBillingApi} from "../../api";
import {useHistory} from "react-router";


export default function SubscriptionPlansView(props) {
    const history = useHistory()
    const {plans, subscriptionNotes, activeSubscriptionName} = props;
    const [selectedPlan, setSelectedPlan] = useState(0);
    console.log(`plans  ${plans}`)

    function SampleNextArrow(props) {
        const {className, style, onClick} = props;
        const nextOnClick = (event) => {
            console.log("next")
            setSelectedPlan(selectedPlan + 1);
            onClick(event)
        }
        return (
            <div
                className={className}
                style={{...style, display: "block"}}
                onClick={nextOnClick}
            />
        );
    }

    function SamplePrevArrow(props) {
        const {className, style, onClick} = props;
        const prevOnClick = (event) => {
            console.log("prev")
            setSelectedPlan(selectedPlan - 1);
            onClick(event)
        }
        return (
            <div
                className={className}
                style={{...style, display: "block"}}
                onClick={prevOnClick}
            />
        );
    }

    const onPlan = (id) => {
        let planId = -1;
        if (plans.length < 1) {
            message.error("پلنی وجود ندارد");
            return 0;
        } else {
            planId = plans[id].id;
        }
        const purchaseChannel = PURCHASE_CHANNEL;
        getBillingApi().createSubscriptionOrder({planId, purchaseChannel})
            .then((response) => history.push(routesConfig.order + "/" + response.id))
            .catch((error) => message.error("خطا در ساخت سفارش!!"))
    }


    const settings = {
        dots: false,
        speed: 500,
        infinite: false,
        slidesToShow: 1,
        centerMode: true,
        slidesToScroll: 1,
        nextArrow: <SampleNextArrow/>,
        prevArrow: <SamplePrevArrow/>,
        centerPadding: 0

    };


    return <React.Fragment>

        {
            (activeSubscriptionName===undefined?
            <div className='px-40'>
                <div className=''>

                    <h4 className="f-30 mt-0 mb-1">خرید اشتراک رورو</h4>
                    <p className='color-primary f-14 mb-36'>شما بسته اشتراک فعال ندارید</p>
                    <p className=' f-22 mb-1'>بسته دلخواه را انتخاب کنید</p>
                    <div className='subscription-carousel-container mb-32  ' style={{direction: 'ltr'}}>


                        <Slider {...settings}> {plans.map(item => {
                            return (<div className='subscription-item' item={item}>
                                <p className='mb-0 f-16'>{item.title}</p>
                                <p className='mb-0 f-20'>{item.price}</p>
                                <p className='mb-0 f-16'>تومان</p>
                            </div>)
                        })} </Slider>
                    </div>
                    <p className=' f-22 mb-1'>مشخصات بسته</p>
                    <List
                        split={false}
                        className='mb-32'
                        size="small"
                        dataSource={subscriptionNotes}
                        renderItem={item => <List.Item className="f-14 color-primary p-0 mb-1"><CheckOutlined
                            className='color-primary ml-1 f-18'/>{item}</List.Item>}
                    />

                    <Button block type="primary" onClick={() => onPlan(selectedPlan)}>
                        انتخاب بسته و پرداخت
                    </Button>
                </div>
            </div>:
                <div className='px-40'>
                    <div className=''>

                        <h4 className="f-30 mt-0 mb-1">بسته‌های اشتراکی رورو</h4>
                        <p className='color-primary f-14 mb-36'>{'بسته ' + activeSubscriptionName + " برای شما فعال است"}</p>
                    </div>
                </div>)
        }

    </React.Fragment>;


}